export default {"src":"/_next/static/media/square.00d93ffd.svg","height":206,"width":820};